'use strict';

var FLOW_ORDER = {
    desktop: 'dpresults',
    mobile: 'dpresults_accommodation',
};

module.exports = function() {
    return FLOW_ORDER[Odigeo.SessionScope.flow];
};
